var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52375 0.219703C6.16651 -0.0732342 8.83355 -0.0732342 11.4763 0.219703C12.9201 0.380883 14.0841 1.51751 14.2536 2.96661C14.567 5.64634 14.567 8.35348 14.2536 11.0332C14.0841 12.4823 12.9201 13.6189 11.4771 13.7809C8.83406 14.0739 6.16676 14.0739 3.52375 13.7809C2.07997 13.6189 0.915978 12.4823 0.746435 11.034C0.432992 8.35398 0.432992 5.64659 0.746435 2.96661C0.915978 1.51751 2.07997 0.380883 3.52375 0.219703ZM11.3014 2.43821C11.0998 2.43821 10.9064 2.51831 10.7638 2.66089C10.6213 2.80347 10.5412 2.99685 10.5412 3.19849C10.5412 3.40013 10.6213 3.59351 10.7638 3.73609C10.9064 3.87867 11.0998 3.95878 11.3014 3.95878C11.5031 3.95878 11.6965 3.87867 11.839 3.73609C11.9816 3.59351 12.0617 3.40013 12.0617 3.19849C12.0617 2.99685 11.9816 2.80347 11.839 2.66089C11.6965 2.51831 11.5031 2.43821 11.3014 2.43821ZM3.88869 6.99991C3.88869 6.04212 4.26917 5.12356 4.94642 4.4463C5.62368 3.76904 6.54224 3.38856 7.50003 3.38856C8.45782 3.38856 9.37638 3.76904 10.0536 4.4463C10.7309 5.12356 11.1114 6.04212 11.1114 6.99991C11.1114 7.9577 10.7309 8.87626 10.0536 9.55352C9.37638 10.2308 8.45782 10.6113 7.50003 10.6113C6.54224 10.6113 5.62368 10.2308 4.94642 9.55352C4.26917 8.87626 3.88869 7.9577 3.88869 6.99991Z",
    fill: "#DADADA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.832d271a900734765fa11021f8f493c5.svg";
export { ForwardRef as ReactComponent };